import { render, staticRenderFns } from "./employArchive.vue?vue&type=template&id=0a0f626e&"
import script from "./employArchive.vue?vue&type=script&lang=js&"
export * from "./employArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports